import { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function TallowProductPage() {
  const [quantity, setQuantity] = useState(1);
  const [activeImage, setActiveImage] = useState(0);
  const [activeTab, setActiveTab] = useState('description');
  const [showNotification, setShowNotification] = useState(false);
  const [showStickyCart, setShowStickyCart] = useState(false);
  const [sliderPosition, setSliderPosition] = useState(50);
  const [isDragging, setIsDragging] = useState(false);
  const addToCartRef = useRef<HTMLDivElement>(null);
  const sliderRef = useRef<HTMLDivElement>(null);

  const images = [
    'https://static.readdy.ai/image/07b995505c26827fb0d464fe2bd78fdd/7d5718d63f1bd6b8af2742ac690c7eba.png',
    'https://static.readdy.ai/image/07b995505c26827fb0d464fe2bd78fdd/298224f808d316de048d95dee2c40eb0.png',
    'https://static.readdy.ai/image/07b995505c26827fb0d464fe2bd78fdd/6e8580007ea67d56d63fec81dbf75d4d.png',
    'https://static.readdy.ai/image/07b995505c26827fb0d464fe2bd78fdd/0694d860e140da609778617bd61796cf.png',
  ];

  const reviews = [
    { name: 'Sarah M.', rating: 5, date: '1 week ago', text: 'My skin has never felt so soft and hydrated. The natural ingredients make such a difference. Love that it\'s suitable for both men and women!', verified: true },
    { name: 'Michael R.', rating: 5, date: '2 weeks ago', text: 'Finally found a moisturizer that actually works. No greasy feeling, just smooth, healthy skin. The honey extract gives it a subtle natural scent.', verified: true },
    { name: 'Emma L.', rating: 5, date: '3 weeks ago', text: 'Been using this for a month now. My dry skin issues are completely gone. The tallow and honey combination is incredible.', verified: true },
    { name: 'David K.', rating: 4, date: '1 month ago', text: 'Great product. Absorbs quickly and keeps my skin moisturized all day. Would definitely recommend to anyone looking for natural skincare.', verified: true },
  ];

  useEffect(() => {
    const handleScroll = () => {
      if (addToCartRef.current) {
        const rect = addToCartRef.current.getBoundingClientRect();
        setShowStickyCart(rect.bottom < 0);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleAddToCart = () => {
    window.open('https://1e6x7u-5j.myshopify.com/cart/63271295582557:1?channel=buy_button', '_blank');
  };

  const handleMouseDown = () => {
    setIsDragging(true);
    const handleMouseMove = (e: MouseEvent) => {
      if (!sliderRef.current) return;
      const rect = sliderRef.current.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const percentage = Math.max(0, Math.min(100, (x / rect.width) * 100));
      setSliderPosition(percentage);
    };

    const handleMouseUp = () => {
      setIsDragging(false);
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };

  const handleTouchStart = () => {
    setIsDragging(true);
  };

  const handleTouchEnd = () => {
    setIsDragging(false);
  };

  const handleSliderMove = (e: React.TouchEvent<HTMLDivElement>) => {
    if (!sliderRef.current) return;
    const rect = sliderRef.current.getBoundingClientRect();
    const clientX = e.touches[0].clientX;
    const x = clientX - rect.left;
    const percentage = Math.max(0, Math.min(100, (x / rect.width) * 100));
    setSliderPosition(percentage);
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar variant="solid" />
      
      {/* Sticky Add to Cart Bar */}
      <div className={`fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-black/10 shadow-[0_-4px_20px_rgba(0,0,0,0.1)] transition-all duration-300 ${showStickyCart ? 'translate-y-0' : 'translate-y-full'}`}>
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-3 md:py-4">
          <div className="flex items-center justify-between gap-4">
            <div className="flex items-center gap-3 md:gap-4">
              <img 
                src={images[0]} 
                alt="JawsThe™ PureTallow" 
                className="w-12 h-12 md:w-14 md:h-14 rounded-lg object-cover object-center"
              />
              <div className="hidden sm:block">
                <h3 className="text-sm font-semibold">JawsThe™ PureTallow</h3>
                <p className="text-xs text-black/50">€34 · Natural Formula</p>
              </div>
            </div>
            <button 
              onClick={handleAddToCart}
              className="flex-1 sm:flex-none sm:w-auto h-12 md:h-14 px-6 md:px-10 bg-gradient-to-r from-black to-black/90 text-white rounded-xl font-semibold text-sm uppercase tracking-wider hover:from-black/90 hover:to-black hover:scale-[1.02] active:scale-[0.98] transition-all cursor-pointer whitespace-nowrap shadow-xl"
            >
              <span className="flex items-center justify-center gap-2">
                <i className="ri-shopping-bag-line text-lg"></i>
                <span className="hidden sm:inline">Add to Cart —</span> €{34 * quantity}
              </span>
            </button>
          </div>
        </div>
      </div>

      {/* Notification */}
      <div className={`fixed top-24 right-4 md:right-8 z-50 bg-black text-white px-4 md:px-6 py-3 md:py-4 rounded-lg shadow-xl transition-all duration-300 ${showNotification ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-8 pointer-events-none'}`}>
        <div className="flex items-center gap-2 md:gap-3">
          <i className="ri-check-line text-lg md:text-xl text-green-400"></i>
          <span className="text-xs md:text-sm font-medium">Added to cart</span>
        </div>
      </div>

      {/* Breadcrumb */}
      <div className="pt-20 md:pt-24 px-4 md:px-20">
        <div className="max-w-7xl mx-auto">
          <nav className="flex items-center gap-2 text-xs text-black/50">
            <Link to="/" className="hover:text-black transition-colors cursor-pointer">Home</Link>
            <span>/</span>
            <span className="cursor-pointer hover:text-black transition-colors">Shop</span>
            <span>/</span>
            <span className="text-black">JawsThe™ PureTallow</span>
          </nav>
        </div>
      </div>

      {/* Product Section */}
      <section className="px-4 md:px-20 py-6 md:py-12">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16">
            {/* Left - Images */}
            <div className="flex flex-col md:flex-row gap-3 md:gap-4">
              {/* Thumbnails */}
              <div className="flex md:flex-col gap-2 md:gap-3 order-2 md:order-1 overflow-x-auto md:overflow-visible">
                {images.map((img, idx) => (
                  <button
                    key={idx}
                    onClick={() => setActiveImage(idx)}
                    className={`w-16 h-20 md:w-20 md:h-24 flex-shrink-0 rounded-lg overflow-hidden border-2 transition-all cursor-pointer ${activeImage === idx ? 'border-black' : 'border-transparent hover:border-black/20'}`}
                  >
                    <img src={img} alt={`View ${idx + 1}`} className="w-full h-full object-cover object-center" />
                  </button>
                ))}
              </div>
              
              {/* Main Image */}
              <div className="flex-1 aspect-[4/5] rounded-2xl overflow-hidden bg-[#F8F8F8] order-1 md:order-2">
                <img 
                  src={images[activeImage]} 
                  alt="JawsThe™ PureTallow" 
                  className="w-full h-full object-cover object-center transition-opacity duration-300"
                />
              </div>
            </div>

            {/* Right - Product Info */}
            <div className="py-2 md:py-4">
              {/* Badge */}
              <div className="inline-flex items-center gap-2 bg-orange-100 px-3 py-1.5 rounded-full mb-3 md:mb-4">
                <span className="w-2 h-2 bg-orange-500 rounded-full animate-pulse"></span>
                <span className="text-[10px] md:text-[11px] uppercase tracking-wider font-semibold text-orange-600">Low in Stock</span>
              </div>

              <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 mb-3">
                <h1 className="text-2xl md:text-4xl font-semibold tracking-tight text-black">
                  JawsThe™ PureTallow
                </h1>
                <span className="bg-black text-white text-[9px] md:text-[10px] uppercase tracking-wider font-semibold px-2.5 md:px-3 py-1 md:py-1.5 rounded-full w-fit">Bestseller</span>
              </div>
              
              {/* Rating */}
              <div className="flex items-center gap-2 md:gap-3 mb-4 md:mb-6">
                <div className="flex items-center gap-1">
                  {[1,2,3,4,5].map(star => (
                    <i key={star} className="ri-star-fill text-black text-xs md:text-sm"></i>
                  ))}
                </div>
                <span className="text-xs md:text-sm text-black/60">4.9 (89 reviews)</span>
              </div>

              {/* Price */}
              <div className="flex items-baseline gap-3 mb-6 md:mb-8">
                <span className="text-2xl md:text-3xl font-semibold">€34</span>
                <span className="text-sm text-black/50">150ml</span>
              </div>

              {/* Short Description */}
              <p className="text-sm md:text-[15px] text-black/70 leading-relaxed mb-5 md:mb-6">
                Premium moisturizing cream made with grass-fed beef tallow and pure honey extract. 
                Deeply nourishes and hydrates all skin types. Suitable for both men and women.
              </p>

              {/* CTA Buttons */}
              <div ref={addToCartRef} className="flex gap-3 md:gap-4 mb-8 md:mb-10">
                <button 
                  onClick={handleAddToCart}
                  className="flex-1 h-14 md:h-16 bg-gradient-to-r from-black to-black/90 text-white rounded-xl font-semibold text-sm md:text-base uppercase tracking-wider hover:from-black/90 hover:to-black hover:scale-[1.02] active:scale-[0.98] transition-all cursor-pointer whitespace-nowrap shadow-xl hover:shadow-2xl ring-2 ring-black/5"
                >
                  <span className="flex items-center justify-center gap-2">
                    <i className="ri-shopping-bag-line text-lg md:text-xl"></i>
                    Add to Cart — €{34 * quantity}
                  </span>
                </button>
                <button className="w-14 h-14 md:w-16 md:h-16 border-2 border-black/10 rounded-xl flex items-center justify-center hover:border-black/30 hover:bg-black/5 transition-all cursor-pointer">
                  <i className="ri-heart-line text-xl md:text-2xl"></i>
                </button>
              </div>

              {/* Quantity */}
              <div className="mb-6 md:mb-8">
                <span className="text-sm font-medium mb-3 block">Quantity</span>
                <div className="inline-flex items-center border border-black/10 rounded-lg">
                  <button 
                    onClick={() => setQuantity(Math.max(1, quantity - 1))}
                    className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center hover:bg-black/5 transition-colors cursor-pointer"
                  >
                    <i className="ri-subtract-line text-base md:text-lg"></i>
                  </button>
                  <span className="w-10 md:w-12 text-center font-medium text-sm md:text-base">{quantity}</span>
                  <button 
                    onClick={() => setQuantity(Math.min(10, quantity + 1))}
                    className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center hover:bg-black/5 transition-colors cursor-pointer"
                  >
                    <i className="ri-add-line text-base md:text-lg"></i>
                  </button>
                </div>
              </div>

              {/* Key Benefits */}
              <div className="mb-6 md:mb-8 p-4 md:p-5 bg-[#FAFAFA] rounded-xl">
                <h4 className="text-xs md:text-sm font-semibold uppercase tracking-wider mb-3 md:mb-4">Key Benefits</h4>
                <ul className="space-y-2 md:space-y-3">
                  {[
                    'Deep hydration & moisture retention',
                    'Rich in vitamins A, D, E & K',
                    'Supports skin barrier function',
                    'Anti-inflammatory properties',
                    'Suitable for all skin types'
                  ].map((benefit, idx) => (
                    <li key={idx} className="flex items-center gap-3 text-sm text-black/70">
                      <i className="ri-check-line text-black"></i>
                      {benefit}
                    </li>
                  ))}
                </ul>
              </div>

              {/* Trust Badges */}
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 py-6 border-t border-b border-black/10">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-black/5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-leaf-line text-lg"></i>
                  </div>
                  <div>
                    <p className="text-xs font-medium">100% Natural</p>
                    <p className="text-[11px] text-black/50">No chemicals</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-black/5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-test-tube-line text-lg"></i>
                  </div>
                  <div>
                    <p className="text-xs font-medium">Dermatologist Tested</p>
                    <p className="text-[11px] text-black/50">Safe for skin</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-black/5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-recycle-line text-lg"></i>
                  </div>
                  <div>
                    <p className="text-xs font-medium">Eco-Friendly</p>
                    <p className="text-[11px] text-black/50">Sustainable</p>
                  </div>
                </div>
              </div>

              {/* Payment Methods */}
              <div className="flex flex-wrap items-center gap-3 md:gap-4 mt-6">
                <span className="text-xs text-black/40">Pay with</span>
                <div className="flex items-center gap-2 md:gap-3">
                  <i className="ri-visa-line text-xl md:text-2xl text-black/40"></i>
                  <i className="ri-mastercard-line text-xl md:text-2xl text-black/40"></i>
                  <i className="ri-paypal-line text-xl md:text-2xl text-black/40"></i>
                  <i className="ri-apple-line text-xl md:text-2xl text-black/40"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Product Details Tabs */}
      <section className="px-4 md:px-20 py-12 md:py-16 bg-[#FAFAFA]">
        <div className="max-w-7xl mx-auto">
          {/* Tab Headers */}
          <div className="flex gap-4 md:gap-8 border-b border-black/10 mb-8 md:mb-10 overflow-x-auto">
            {['description', 'ingredients', 'how to use', 'reviews'].map(tab => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`pb-3 md:pb-4 text-xs md:text-sm uppercase tracking-wider font-medium transition-all cursor-pointer whitespace-nowrap ${
                  activeTab === tab 
                    ? 'text-black border-b-2 border-black' 
                    : 'text-black/40 hover:text-black/60'
                }`}
              >
                {tab}
              </button>
            ))}
          </div>

          {/* Tab Content */}
          {activeTab === 'description' && (
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16">
              <div>
                <h3 className="text-xl md:text-2xl font-semibold mb-4 md:mb-6">Nature's Perfect Moisturizer</h3>
                <p className="text-sm md:text-[15px] text-black/70 leading-relaxed mb-4 md:mb-6">
                  Our JawsThe™ PureTallow combines the ancient wisdom of tallow-based skincare with modern 
                  formulation techniques. Grass-fed beef tallow is remarkably similar to human sebum, making it 
                  one of the most biocompatible moisturizers available.
                </p>
                <p className="text-sm md:text-[15px] text-black/70 leading-relaxed mb-6 md:mb-8">
                  Enhanced with pure honey extract, this cream provides deep hydration while supporting your 
                  skin's natural barrier function. Suitable for all skin types and gentle enough for sensitive skin.
                </p>
                
                <h4 className="text-xs md:text-sm font-semibold uppercase tracking-wider mb-3 md:mb-4">Why Tallow?</h4>
                <ul className="space-y-2 md:space-y-3">
                  {[
                    'Bioidentical to human skin oils',
                    'Rich in fat-soluble vitamins',
                    'Non-comedogenic (won\'t clog pores)',
                    'Long-lasting moisture retention',
                    'Anti-aging properties'
                  ].map((feature, idx) => (
                    <li key={idx} className="flex items-center gap-3 text-sm text-black/70">
                      <i className="ri-check-line text-black"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
              
              {/* Before/After Slider */}
              <div className="flex flex-col">
                <div className="bg-gradient-to-r from-black/5 to-transparent rounded-2xl p-4 md:p-6 mb-4">
                  <div className="flex items-center gap-3 mb-2">
                    <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-black flex items-center justify-center">
                      <i className="ri-contrast-2-line text-white text-sm md:text-base"></i>
                    </div>
                    <div>
                      <h4 className="text-sm md:text-base font-semibold">Real Results</h4>
                      <p className="text-xs text-black/50">Drag to compare before & after</p>
                    </div>
                  </div>
                </div>
                <div 
                  ref={sliderRef}
                  className="relative aspect-square rounded-2xl overflow-hidden cursor-ew-resize select-none shadow-2xl ring-4 ring-black/5"
                  onMouseDown={handleMouseDown}
                  onTouchStart={handleTouchStart}
                  onTouchEnd={handleTouchEnd}
                  onTouchMove={handleSliderMove}
                >
                  {/* After Image (Background) */}
                  <img 
                    src="https://static.readdy.ai/image/07b995505c26827fb0d464fe2bd78fdd/9c91333bc499f804845bc15c544edca5.jpeg"
                    alt="After"
                    className="absolute inset-0 w-full h-full object-cover object-center"
                    draggable={false}
                  />
                  
                  {/* Before Image (Clipped) */}
                  <div 
                    className="absolute inset-0 overflow-hidden"
                    style={{ width: `${sliderPosition}%` }}
                  >
                    <img 
                      src="https://static.readdy.ai/image/07b995505c26827fb0d464fe2bd78fdd/19e2b479c9e08f488bc14f192c300d93.jpeg"
                      alt="Before"
                      className="absolute inset-0 w-full h-full object-cover object-center"
                      style={{ width: sliderRef.current ? `${sliderRef.current.offsetWidth}px` : '100%', maxWidth: 'none' }}
                      draggable={false}
                    />
                  </div>
                  
                  {/* Slider Line */}
                  <div 
                    className="absolute top-0 bottom-0 w-1 bg-white shadow-2xl"
                    style={{ left: `${sliderPosition}%`, transform: 'translateX(-50%)' }}
                  >
                    {/* Slider Handle */}
                    <div className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 md:w-14 md:h-14 bg-white rounded-full shadow-2xl flex items-center justify-center cursor-ew-resize ring-4 transition-all ${isDragging ? 'ring-black/30 scale-110' : 'ring-black/10 hover:ring-black/20'}`}>
                      <div className="flex items-center gap-0.5">
                        <i className="ri-arrow-left-s-line text-black text-base md:text-lg"></i>
                        <i className="ri-arrow-right-s-line text-black text-base md:text-lg"></i>
                      </div>
                    </div>
                  </div>
                  
                  {/* Labels */}
                  <div className="absolute bottom-4 md:bottom-5 left-4 md:left-5 bg-black text-white text-xs md:text-sm px-3 md:px-4 py-1.5 md:py-2 rounded-full font-medium shadow-lg">
                    Before
                  </div>
                  <div className="absolute bottom-4 md:bottom-5 right-4 md:right-5 bg-white text-black text-xs md:text-sm px-3 md:px-4 py-1.5 md:py-2 rounded-full font-medium shadow-lg">
                    After
                  </div>
                </div>
                <div className="flex items-center justify-center gap-2 mt-4 text-black/50">
                  <i className="ri-drag-move-2-line text-lg animate-pulse"></i>
                  <p className="text-xs md:text-sm font-medium">
                    Drag the slider to see the transformation
                  </p>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'ingredients' && (
            <div className="max-w-3xl">
              <h3 className="text-xl md:text-2xl font-semibold mb-6 md:mb-8">Full Ingredient List</h3>
              <div className="bg-white p-6 md:p-8 rounded-xl shadow-sm mb-8">
                <p className="text-sm md:text-base text-black/80 leading-relaxed">
                  <strong>Ingredients:</strong> Water, Glycerin, Mineral Oil, Glycerol Stearate, 1,2-Hexanediol, 
                  Carbomer, Triethanolamine, Tallow and Honey Extract.
                </p>
              </div>

              <h4 className="text-base md:text-lg font-semibold mb-4 md:mb-6">What Each Ingredient Does</h4>
              <div className="space-y-4 md:space-y-6">
                {[
                  { 
                    name: 'Beef Tallow', 
                    desc: 'Rich in vitamins A, D, E, and K. Provides deep moisturization and supports skin barrier function. Bioidentical to human sebum.' 
                  },
                  { 
                    name: 'Honey Extract', 
                    desc: 'Natural humectant that draws moisture into the skin. Contains antioxidants and has antibacterial properties.' 
                  },
                  { 
                    name: 'Glycerin', 
                    desc: 'Powerful moisturizer that helps skin retain water. Creates a protective barrier on the skin\'s surface.' 
                  },
                  { 
                    name: 'Water', 
                    desc: 'Base ingredient that helps deliver nutrients and keeps the formula lightweight and spreadable.' 
                  },
                  { 
                    name: 'Glycerol Stearate', 
                    desc: 'Emulsifier that helps blend oil and water-based ingredients for a smooth, creamy texture.' 
                  },
                ].map((ingredient, idx) => (
                  <div key={idx} className="bg-white p-4 md:p-5 rounded-lg">
                    <h5 className="text-sm md:text-base font-medium mb-2">{ingredient.name}</h5>
                    <p className="text-xs md:text-sm text-black/60 leading-relaxed">{ingredient.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          )}

          {activeTab === 'how to use' && (
            <div className="max-w-3xl">
              <h3 className="text-xl md:text-2xl font-semibold mb-6 md:mb-8">Application Guide</h3>
              <div className="space-y-6 md:space-y-8">
                {[
                  { 
                    step: '01', 
                    title: 'Cleanse', 
                    desc: 'Start with clean, dry skin. Gently wash your face with a mild cleanser and pat dry with a soft towel.' 
                  },
                  { 
                    step: '02', 
                    title: 'Apply', 
                    desc: 'Take a small amount (pea-sized) of cream and warm it between your fingertips. The tallow will melt slightly from your body heat.' 
                  },
                  { 
                    step: '03', 
                    title: 'Massage', 
                    desc: 'Gently massage the cream into your skin using upward circular motions. Focus on dry areas and allow it to fully absorb.' 
                  },
                  { 
                    step: '04', 
                    title: 'Routine', 
                    desc: 'Use twice daily - morning and evening - for best results. A little goes a long way with this concentrated formula.' 
                  },
                ].map((item, idx) => (
                  <div key={idx} className="flex gap-4 md:gap-6">
                    <span className="text-2xl md:text-4xl font-light text-black/20">{item.step}</span>
                    <div>
                      <h4 className="text-base md:text-lg font-medium mb-2">{item.title}</h4>
                      <p className="text-sm md:text-[15px] text-black/60">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-8 md:mt-10 bg-green-50 p-6 md:p-8 rounded-xl">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-lightbulb-line text-green-600 text-lg"></i>
                  </div>
                  <div>
                    <h5 className="text-sm font-semibold mb-2">Pro Tip</h5>
                    <p className="text-sm text-black/70 leading-relaxed">
                      For extra dry skin, apply a slightly thicker layer before bed and let it work overnight. 
                      You'll wake up with deeply nourished, glowing skin.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'reviews' && (
            <div>
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-8 md:mb-10">
                <div>
                  <div className="flex items-center gap-3 md:gap-4 mb-2">
                    <span className="text-3xl md:text-5xl font-semibold">4.9</span>
                    <div>
                      <div className="flex items-center gap-1 mb-1">
                        {[1,2,3,4,5].map(star => (
                          <i key={star} className="ri-star-fill text-black text-sm md:text-base"></i>
                        ))}
                      </div>
                      <p className="text-xs md:text-sm text-black/50">Based on 89 reviews</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="space-y-4 md:space-y-6">
                {reviews.map((review, idx) => (
                  <div key={idx} className="bg-white p-4 md:p-6 rounded-xl">
                    <div className="flex items-start justify-between mb-3 md:mb-4">
                      <div className="flex items-center gap-2 md:gap-3">
                        <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-black/10 flex items-center justify-center flex-shrink-0">
                          <span className="text-xs md:text-sm font-medium">{review.name.charAt(0)}</span>
                        </div>
                        <div>
                          <p className="text-xs md:text-sm font-medium">{review.name}</p>
                          <div className="flex items-center gap-2">
                            <div className="flex items-center gap-0.5">
                              {[1,2,3,4,5].map(star => (
                                <i key={star} className={`ri-star-fill text-xs ${star <= review.rating ? 'text-black' : 'text-black/20'}`}></i>
                              ))}
                            </div>
                            {review.verified && (
                              <span className="text-[9px] md:text-[10px] text-green-600 bg-green-50 px-1.5 py-0.5 rounded">Verified</span>
                            )}
                          </div>
                        </div>
                      </div>
                      <span className="text-[10px] md:text-xs text-black/40">{review.date}</span>
                    </div>
                    <p className="text-xs md:text-sm text-black/70 leading-relaxed">{review.text}</p>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Social Proof Banner */}
      <section className="px-4 md:px-20 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="bg-black rounded-2xl p-8 md:p-12 text-white text-center">
            <p className="text-[10px] md:text-[11px] uppercase tracking-[0.2em] text-white/50 mb-3 md:mb-4">Trusted by skincare enthusiasts</p>
            <h2 className="text-2xl md:text-3xl font-semibold mb-3 md:mb-4">Natural Beauty, Real Results</h2>
            <p className="text-sm md:text-base text-white/60 max-w-xl mx-auto mb-6 md:mb-8">
              Join thousands who have discovered the power of nature's perfect moisturizer.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-6 md:gap-12">
              <div>
                <p className="text-3xl md:text-4xl font-semibold">100%</p>
                <p className="text-xs text-white/50 mt-1">Natural ingredients</p>
              </div>
              <div className="hidden sm:block w-px h-12 bg-white/20"></div>
              <div>
                <p className="text-3xl md:text-4xl font-semibold">4.9</p>
                <p className="text-xs text-white/50 mt-1">Average rating</p>
              </div>
              <div className="hidden sm:block w-px h-12 bg-white/20"></div>
              <div>
                <p className="text-3xl md:text-4xl font-semibold">5K+</p>
                <p className="text-xs text-white/50 mt-1">Happy customers</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
